'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHeaderCombinations = undefined;

var _ramda = require('ramda');

var R = _interopRequireWildcard(_ramda);

var _src = require('../../rules/src');

var _combinedValuesDisplay = require('./combinedValuesDisplay');

var _constants = require('./constants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var getHeaderCombinations = exports.getHeaderCombinations = function getHeaderCombinations(combinations, dimensions, attributes, display) {
  var indexedDimensions = R.indexBy(R.prop('id'), dimensions);
  var indexedAttributes = R.indexBy(R.prop('id'), attributes);
  return R.reduce(function (acc, comb) {
    if (!R.prop('header', comb) || !R.propOr(true, 'display', comb)) {
      return acc;
    }

    var header = (0, _src.dimensionValueDisplay)(display)(comb) + ':';

    var label = R.pipe(R.reduce(function (_acc, concept) {
      var artefact = R.has(concept, indexedDimensions) ? R.prop(concept, indexedDimensions) : R.prop(concept, indexedAttributes);
      if (R.isNil(artefact)) {
        return _acc;
      }
      var value = R.path(['values', 0], artefact);
      if (R.isNil(value)) {
        return _acc;
      }
      if (R.has(concept, indexedAttributes) && (!R.propOr(true, 'display', value) || !R.propOr(true, 'artefact', value) || R.includes(value.id, _constants.REJECTED_VALUE_IDS))) {
        return _acc;
      }
      return R.append(value, _acc);
    }, []), function (values) {
      return (0, _combinedValuesDisplay.combinedValuesDisplay)(display, values);
    })(comb.concepts || []);
    if (R.isEmpty(label)) {
      return acc;
    }
    return R.append({ header: header, label: label }, acc);
  }, [], combinations);
};